import React from "react";
import { Image } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import BenchLogoImage from "../../../assets/Bench_Logo.png";

const BenchLogo: React.FC = () => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate("/home");
    };

    return (
        <Image
            src={BenchLogoImage}
            alt="Bench Logo"
            width={120}
            style={{ cursor: "pointer" }}
            onClick={handleLogoClick}
        />
    );
};

export default BenchLogo;
